import React from "react";

const partnerBg = new URL("@/app/assets/partner-bg.png", import.meta.url).href;

const PartnersSection = () => {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 text-white overflow-hidden bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="absolute inset-0 z-0 opacity-10">
        <div
          className="absolute top-0 left-0 w-full h-full bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${partnerBg})`,
          }}
        ></div>
      </div>
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Trusted ways to play, powered by Casino24
        </h2>
        <p className="text-sm md:text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
          CasinoB8 gives you strategies and insights. When you are ready to play
          for real, Casino24 connects you with verified casinos, exclusive
          deals, and top sports betting options.
        </p>

        <div className="grid gap-4 md:gap-6 md:grid-cols-3 text-left">
          <a
            href="https://www.casino24.com/casinos"
            target="_blank"
            rel="noopener noreferrer"
            className="group block h-full rounded-2xl bg-black/30 border border-white/10 p-4 md:p-5 hover:border-yellow-400 hover:bg-black/50 transition-colors"
          >
            <h3 className="text-sm md:text-base font-semibold mb-1">
              Verified casinos
            </h3>
            <p className="text-xs md:text-sm text-gray-300">
              Browse licensed and verified casino brands available via Casino24.
            </p>
          </a>

          <a
            href="https://www.casino24.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="group block h-full rounded-2xl bg-black/30 border border-white/10 p-4 md:p-5 hover:border-yellow-400 hover:bg-black/50 transition-colors"
          >
            <h3 className="text-sm md:text-base font-semibold mb-1">
              Exclusive deals
            </h3>
            <p className="text-xs md:text-sm text-gray-300">
              Discover welcome offers and exclusive casino deals curated by
              Casino24.
            </p>
          </a>

          <a
            href="https://www.casino24.com/sports-betting"
            target="_blank"
            rel="noopener noreferrer"
            className="group block h-full rounded-2xl bg-black/30 border border-white/10 p-4 md:p-5 hover:border-yellow-400 hover:bg-black/50 transition-colors"
          >
            <h3 className="text-sm md:text-base font-semibold mb-1">
              Sports betting
            </h3>
            <p className="text-xs md:text-sm text-gray-300">
              Compare top sports betting sites, odds and promotions with
              Casino24.
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
